<template>
    <b-row class="mb-3 mt-4">
        <b-col cols="12" v-html="data.content"></b-col>
    </b-row>
</template>
<style lang="scss" scoped>
</style>    
<script>
    export default {
        name: 'pre-parrafo',
        props: {
            data: {
                type: Object,
                default: () => {
                    return {
                        index: null,
                        tag: 'Parrafo',
                        content: ''//modificado
                    }
                }
            }
        },
        created() {
            console.log(this.data.content)
        }
    }
</script>